<template>
  <b-modal v-model="showModal"
           hide-footer
           :hide-header-close="(jobUser && !validateJobUserInfo())"
           :no-close-on-esc="(jobUser && !validateJobUserInfo())"
           :no-close-on-backdrop="(jobUser && !validateJobUserInfo())"
           scrollable
  >
    <div slot="modal-title">
      ข้อมูลโปรไฟล์
    </div>
    <section>
      <div v-if="_.size(requireNameInputs) > 0" class="form-group">
        <h3 class="text-danger text-center">ไม่สามารถดำเนินการสนใจงานได้ <i class="fas fa-exclamation-circle"></i> <br> โปรดระบุข้อมูลให้ครบถ้วน </h3>
      </div>

      <div class="form-group">
        <label for="prefixName">คำนำหน้าชื่อ <span style="color: red;">* จำเป็น</span></label>
        <select name="prefixName"
                class="form-control"
                :class="{'form-alert': errors.has('prefixName')}"
                v-validate="'required'"
                v-model="prefixName">
          <option :value="null">เลือกคำนำหน้าชื่อ</option>
          <option v-for="(item,index) in prefixNames" :value="item" :key="index">
            {{ item }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="name">ชื่อ-สกุล (ตามบัตรประชาชน) <span style="color: red;">* จำเป็น</span></label>
        <input type="text"
               class="form-control"
               :class="{'form-alert': errors.has('name')}"
               id="name"
               name="name"
               v-validate="'required'"
               v-model="name">
        <div class="mt-1 text-remark -status-alert" v-if="errors.has('name')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <div class="form-group">
        <label for="tel">เบอร์โทร <span style="color: red;">* จำเป็น</span></label>
        <input type="tel"
               class="form-control"
               :class="{'form-alert': errors.has('tel')}"
               id="tel"
               name="tel"
               v-validate="{ required: true, min: 10, max: 15, regex: /^\+?[0-9-]+$/ }"
               v-model="tel">
        <div class="mt-1 text-remark -status-alert" v-if="errors.has('tel')">
          {{ $t('message.required_field') }}
        </div>
      </div>

      <div class="form-group">
        <label for="age">วัน-เดือน-ปีเกิด <span style="color: red;">* จำเป็น</span></label>
        <div class="d-flex">
          <div class="flex-fill">
            <select name="bDay"
                    class="form-control"
                    :class="{'form-alert': errors.has('bDay')}"
                    v-validate="'required'"
                    v-model="bDay">
              <option :value="null">วัน</option>
              <option v-for="(day,index) in days" :value="day" :key="index">
                {{ day }}
              </option>
            </select>
          </div>
          <div class="flex-fill px-3">
            <select name="bMonth"
                    class="form-control"
                    :class="{'form-alert': errors.has('bMonth')}"
                    v-validate="'required'"
                    v-model="bMonth">
              <option :value="null">เดือน</option>
              <option v-for="(month,index) in months" :value="(index + 1)" :key="index">
                {{ month }}
              </option>
            </select>
          </div>
          <div class="flex-fill">
            <select name="bYear"
                    class="form-control"
                    :class="{'form-alert': errors.has('bYear')}"
                    v-validate="'required'"
                    v-model="bYear">
              <option :value="null">ปีพ.ศ.</option>
              <option v-for="(year,index) in years" :value="year" :key="index">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="age">จังหวัด และเขต/อำเภอที่ฉันอยู่ (ปัจจุบัน) <span style="color: red;">* จำเป็น</span></label>
        <div class="row no-gutters">
          <div class="col-6 pr-2">
            <select v-model="addressProvinceId"
                    class="form-control"
                    :class="{'form-alert': (errors.has('addressProvince') || (_.findKey('address_province_id') && !addressProvinceId ) )}"
                    v-validate="'required'"
                    name="addressProvince">
              <option :value="null">{{ $t('message.booking.contact_step.set_province') }}</option>
              <option :value="addressProvince.id" v-for="(addressProvince, index) in sortedProvinces">
                {{ addressProvince | multiLangName }}
              </option>
            </select>
            <div class="mt-1 text-remark -status-alert" v-if="(errors.has('addressProvince') || (_.findKey('address_province_id') && !addressProvinceId ) )">
              {{ $t('message.required_field') }}
            </div>
          </div>
          <div class="col-6 pl-2">
            <select v-model="districtId"
                    class="form-control"
                    :class="{'form-alert': (errors.has('district') || (_.findKey('district') && !districtId ) )}"
                    v-validate="'required'"
                    name="district">
              <option :value="null">{{ $t('message.booking.contact_step.set_district') }}</option>
              <option :value="district.id" v-for="(district, index) in sortedDistricts">
                {{ district | multiLangName }}
              </option>
            </select>
            <div class="mt-1 text-remark -status-alert" v-if="(errors.has('district') || (_.findKey('district') && !districtId ) )">
              {{ $t('message.required_field') }}
            </div>
          </div>
        </div>
      </div>

      <hr>


      <div class="d-flex mb-3">
        <div class="flex-fill py-1">
          <label for="maritalStatus">สถานภาพ <span style="color: red;">* จำเป็น</span></label>
          <select name="maritalStatus" id="maritalStatus" v-validate="'required'"
                  class="form-control" v-model="maritalStatus"
                  :class="{'form-alert': errors.has('maritalStatus')}"
          >
            <option value="">เลือกสถานภาพ</option>
            <option value="โสด">โสด</option>
            <option value="สมรส">สมรส</option>
          </select>
          <div class="mt-1 text-remark -status-alert" v-if="errors.has('maritalStatus')">
            {{ $t('message.required_field') }}
          </div>
        </div>
      </div>


      <div class="d-flex mb-3">
        <div class="flex-fill py-1">
          <h4>ทักษะขับรถยนต์</h4>
          <label>
            <input type="radio" name="drivingCar" value="ขับไม่ได้" v-model="drivingCar"> ขับไม่ได้
          </label>
          <label>
            <input type="radio" name="drivingCar" value="ขับได้มีใบขับขี่" v-model="drivingCar"> ขับได้มีใบขับขี่
          </label>
          <label>
            <input type="radio" name="drivingCar" value="ขับได้ไม่มีใบขับขี่" v-model="drivingCar"> ขับได้ไม่มีใบขับขี่
          </label>
        </div>
      </div>

      <div class="d-flex mb-3">
        <div class="flex-fill py-1">
          <h4>ทักษะขับรถมอเตอร์ไซค์</h4>
          <label>
            <input type="radio" name="drivingMotorcycle" value="ขับไม่ได้" v-model="drivingMotorcycle"> ขับไม่ได้
          </label>
          <label>
            <input type="radio" name="drivingMotorcycle" value="ขับได้มีใบขับขี่" v-model="drivingMotorcycle"> ขับได้มีใบขับขี่
          </label>
          <label>
            <input type="radio" name="drivingMotorcycle" value="ขับได้ไม่มีใบขับขี่" v-model="drivingMotorcycle"> ขับได้ไม่มีใบขับขี่
          </label>
        </div>
      </div>

      <div class="d-flex mb-3">
        <div class="flex-fill py-1">
          <label>โรคประจำตัว (หากไม่มีให้ใส่เครื่องหมายขีด - ) <span style="color: red;">* จำเป็น</span></label>
          <input type="text" name="disease" class="form-control" v-validate="'required'"
                 :class="{'form-alert': (errors.has('disease') || (_.findKey('disease') && !disease ) ) }"
                 v-model="disease">
          <div class="mt-1 text-remark -status-alert" v-if="(errors.has('disease') || (_.findKey('disease') && !disease ) )">
            {{ $t('message.required_field') }}
          </div>
        </div>
      </div>

      <div class="d-flex mb-3">
        <div class="flex-fill py-1">
          <label>แนะนำตัวเอง <span style="color: red;">* จำเป็น</span></label>
          <textarea name="introduce" id="introduce" v-validate="'required'"
                    :class="{'form-alert': (errors.has('introduce') || (_.findKey('introduce') && !introduce ) )   }"
                    rows="4" v-model="introduce" class="form-control"></textarea>
          <div class="mt-1 text-remark -status-alert" v-if="(errors.has('introduce') || (_.findKey('introduce') && !introduce ) ) ">
            {{ $t('message.required_field') }}
          </div>
        </div>
      </div>

      <div class="d-flex mb-3">
        <div class="flex-fill py-1">
          <label>ประสบการณ์ทำงาน <span style="color: red;">* จำเป็น</span></label>
          <textarea name="workingExperience" v-validate="'required'"
                    :class="{'form-alert': (errors.has('workingExperience') || (_.findKey('working_experience') && !workingExperience ) )}"
                    id="workingExperience" rows="4" v-model="workingExperience" class="form-control"></textarea>
          <div class="mt-1 text-remark -status-alert" v-if="(errors.has('workingExperience') || (_.findKey('working_experience') && !workingExperience ) )">
            {{ $t('message.required_field') }}
          </div>
        </div>
      </div>


      <div class="d-flex">
        <div class="flex-fill">
          <h3>ทักษะของฉัน</h3>
          <div class="py-1" v-for="(jobSkill, index) in jobSkills" :key="index">
            <label>
              <input type="checkbox"
                     :value="jobSkill.id"
                     :checked="hasSkill(jobSkill.id)"
                     @change="changeHasSkill">&nbsp;&nbsp;{{ jobSkill.name }}
            </label>
          </div>
        </div>
        <div class="flex-fill">
          <h3>ภาษาที่ฉันสื่อสารได้</h3>
          <div class="py-1" v-for="(jobLanguage, index) in jobLanguages" :key="index">
            <label>
              <input type="checkbox"
                     :value="jobLanguage.id"
                     :checked="hasLanguage(jobLanguage.id)"
                     @change="changeHasLanguage">&nbsp;&nbsp;{{ (jobLanguage.name === 'Thai') ?
              jobLanguage.native
              : jobLanguage.name }}
            </label>
          </div>
        </div>
      </div>

      <div class="mt-3 row no-gutters">
        <div class="col-12">
          <button class="btn btn-info btn-block"
                  :disabled="isLoading"
                  @click="saveData()">
            {{ isLoading ? 'กำลังบันทึก...' : 'บันทึก' }}
          </button>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import i18n from '../../helpers/i18nHelpers'

export default {
  data () {
    return {
      showModal: false,
      prefixName: null,
      name: null,
      tel: null,
      age: null,
      bDay: null,
      bMonth: null,
      bYear: null,
      isLoading: false,
      days: [],
      months: [],
      years: [],
      addressProvinceId: null,
      districtId: null,
      maritalStatus: '',
      introduce: '',
      workingExperience: '',
      disease: '',
      drivingCar: '',
      drivingMotorcycle: '',
      requireNameInputs: []
    }
  },
  computed: {
    ...mapState('jobUser', ['jobUser', 'jobSkills', 'jobLanguages']),
    ...mapState({
      prefixNames: state => state.globalVal.prefixName
    }),
    ...mapState('addressProvince', ['addressProvinces', 'districts']),
    sortedProvinces () {
      return this._.orderBy(this.addressProvinces, [this.sortBy], ['asc'])
    },
    sortedDistricts () {
      return this._.orderBy(this.districts, [this.sortBy], ['asc'])
    }
  },
  watch: {
    async addressProvinceId () {
      if (this.addressProvinceId) {
        this.districtId = null
        await this.fetchDistricts(this.addressProvinceId)
        if (this.jobUser.district_id) {
          this.districtId = this.jobUser.district_id
        }
      }
    }
  },
  methods: {
    ...mapActions('jobUser', ['updateJobUser', 'addJobUserJobSkill', 'deleteJobUserJobSkill', 'addJobUserLanguage', 'deleteJobUserLanguage']),
    saveData () {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.isLoading = true
          const birthDate = this.getBirthDate()
          const submitData = {
            id: this.jobUser.id,
            prefix_name: this.prefixName,
            name: this.name,
            tel: this.tel,
            birth_date: birthDate,
            address_province_id: this.addressProvinceId,
            district_id: this.districtId,
            introduce: this.introduce,
            working_experience: this.workingExperience,
            marital_status: this.maritalStatus,
            disease: this.disease,
            driving_car: this.drivingCar,
            driving_motorcycle: this.drivingMotorcycle
          }
          console.log('submit', submitData)
          await this.updateJobUser(submitData)
          this.isLoading = false
          this.displayModal(false)
        }
      })
    },
    displayModal (status, requireNameInputs = []) {
      this.showModal = status
      this.requireNameInputs = requireNameInputs
      if (status) {
        this.prefixName = this.jobUser.prefix_name
        this.name = this.jobUser.name
        this.tel = this.jobUser.tel
        this.addressProvinceId = this.jobUser.address_province_id
        this.districtId = this.jobUser.district_id
        this.introduce = this.jobUser.introduce
        this.workingExperience = this.jobUser.working_experience
        this.maritalStatus = this.jobUser.marital_status
        this.disease = this.jobUser.disease
        this.drivingCar = this.jobUser.driving_car
        this.drivingMotorcycle = this.jobUser.driving_motorcycle
        // Check job user birth date
        if (this.jobUser.birth_date) {
          const arrDates = this.convertBirthDate(this.jobUser.birth_date)
          this.bDay = arrDates[2]
          this.bMonth = arrDates[1]
          this.bYear = arrDates[0]
        }
      }
    },
    getBirthDate () {
      const year = this.bYear - 543
      const month = ('0' + this.bMonth).slice(-2)
      const day = ('0' + this.bDay).slice(-2)
      return `${year}-${month}-${day}`
    },
    convertBirthDate (birthDate) {
      const arr = birthDate.split('-')
      arr[0] = Number(arr[0]) + 543
      arr[1] = Number(arr[1])
      arr[2] = Number(arr[2])
      return arr
    },
    async fetchDistricts (provinceId) {
      if (provinceId) {
        const queryData = {
          province_id: provinceId
        }
        await this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
      }
    },
    prepareBirthDate () {
      for (let i = 1; i <= 31; i++) {
        this.days.push(i)
      }
      this.months = [
        i18n.t('message.calendar.month.01'),
        i18n.t('message.calendar.month.02'),
        i18n.t('message.calendar.month.03'),
        i18n.t('message.calendar.month.04'),
        i18n.t('message.calendar.month.05'),
        i18n.t('message.calendar.month.06'),
        i18n.t('message.calendar.month.07'),
        i18n.t('message.calendar.month.08'),
        i18n.t('message.calendar.month.09'),
        i18n.t('message.calendar.month.10'),
        i18n.t('message.calendar.month.11'),
        i18n.t('message.calendar.month.12')
      ]
      const maxYear = new Date().getFullYear() + 543
      for (let i = 2490; i <= maxYear; i++) {
        this.years.push(i)
      }
    },
    validateJobUserInfo () {
      let valid = true
      if (!this.jobUser.prefix_name) valid = false
      if (!this.jobUser.name) valid = false
      if (!this.jobUser.tel) valid = false
      if (!this.jobUser.birth_date) valid = false
      if (!this.jobUser.address_province_id) valid = false
      if (!this.jobUser.district_id) valid = false
      return valid
    },
    hasSkill (jobSkillId) {
      let result = false
      for (const jobUserJobSkill of this.jobUser.job_user_job_skills) {
        if (jobUserJobSkill.job_skill_id === jobSkillId) {
          result = true
          break
        }
      }
      return result
    },
    hasLanguage (languageId) {
      let result = false
      for (const jobUserLanguage of this.jobUser.job_user_languages) {
        if (jobUserLanguage.language_id === languageId) {
          result = true
          break
        }
      }
      return result
    },
    changeHasSkill (event) {
      const status = event.target.checked
      const jobSkillId = Number(event.target.value)
      const submitData = {
        job_user_id: this.jobUser.id,
        job_skill_id: jobSkillId
      }
      if (status) {
        this.addJobUserJobSkill(submitData)
      } else {
        this.deleteJobUserJobSkill(submitData)
      }
    },
    changeHasLanguage (event) {
      const status = event.target.checked
      const languageId = Number(event.target.value)
      const submitData = {
        job_user_id: this.jobUser.id,
        language_id: languageId
      }
      if (status) {
        this.addJobUserLanguage(submitData)
      } else {
        this.deleteJobUserLanguage(submitData)
      }
    }
  },
  async mounted () {
    this.prepareBirthDate()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jobPost/UpdateProfileModal.vue